export const TIMEZONE_STORAGE_KEY = "ofisgorev_timezone";
export const DEFAULT_TIMEZONE = "Europe/Istanbul";

export const TIMEZONE_OPTIONS = [
  ["Europe/Istanbul", "Türkiye — İstanbul (UTC+3)"],
  ["Europe/Paris", "Fransa — Paris"],
  ["Europe/London", "Birleşik Krallık — Londra"],
  ["Europe/Berlin", "Almanya — Berlin"],
  ["Asia/Dubai", "BAE — Dubai"],
  ["America/New_York", "ABD — New York"],
  ["America/Los_Angeles", "ABD — Los Angeles"],
  ["UTC", "UTC"],
];

export function getAppTimezone() {
  return localStorage.getItem(TIMEZONE_STORAGE_KEY) || DEFAULT_TIMEZONE;
}

export function setAppTimezone(timezone) {
  if (!timezone) return;
  localStorage.setItem(TIMEZONE_STORAGE_KEY, timezone);
  window.dispatchEvent(new CustomEvent("ofisgorev-timezone-change", { detail: timezone }));
}

export function installTimezoneLocalePatch() {
  if (window.__ofisgorevTimezonePatchInstalled) return;
  window.__ofisgorevTimezonePatchInstalled = true;

  const patch = (method) => {
    const original = Date.prototype[method];
    Date.prototype[method] = function patchedLocaleDate(locales, options) {
      const opts = { ...(options || {}) };
      if (!opts.timeZone) opts.timeZone = getAppTimezone();
      return original.call(this, locales, opts);
    };
  };

  patch("toLocaleString");
  patch("toLocaleDateString");
  patch("toLocaleTimeString");
}
